import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useOfflineCompat } from '@/composables/useOfflineCompat';
import { useRest } from "@/composables/useRest";


export const useDependenciasStore = defineStore('dependencias', () => {
  const dependencias = ref([])
  const dependenciasListLoad = ref(false)

  const offline = useOfflineCompat();
  const rest = useRest()

  async function setDependencias(refresh = false) {
    try {
      let datos = []
      if (dependenciasListLoad.value && !refresh) return

      if (!refresh && offline.offlineServer) {
        let r = await offline.getList("Dependencias")
        if (Array.isArray(r.data.data) && r.data.data.length > 0 && r.data.data[0].list) {
          datos = r.data.data[0].list
        }
      }

      if (!datos || refresh || datos.length < 1) {
        const url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/parametros/dependencia`
        const r = await rest.get({ url })
        datos = r.data.data.map(element => ({
          dependencia: element.Nombre,
          tel: element.Telefonos,
          localidad: element.Departamento,
          id: element.DependenciaID,
          coordenadas1: null,
          coordenadas2: null
        }))
        offline.setList("Dependencias", datos)
      }

      dependencias.value = datos
      dependenciasListLoad.value = true
    } catch (e) {
      console.error("setDependencias>>", e)
    }
  }

  return {
    dependencias,
    dependenciasListLoad,
    setDependencias
  }
})
